import { css } from '@/styled-system/css';

export const miniMapContainer = css({
  width: '42px',
  height: '42px',
  borderRadius: '4px',
  overflow: 'hidden',
  flexShrink: 0,
  position: 'relative',
});

export const miniMapImage = css({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
});

export const pinOverlay = css({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  pointerEvents: 'none',
});
